import { render, staticRenderFns } from "./mating-list-card-component.vue?vue&type=template&id=fa49d800&scoped=true&lang=pug"
import script from "./mating-list-card-component.js?vue&type=script&lang=js&external"
export * from "./mating-list-card-component.js?vue&type=script&lang=js&external"
import style0 from "./mating-list-card-component.vue?vue&type=style&index=0&id=fa49d800&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa49d800",
  null
  
)

export default component.exports